<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                <loading :show="isLoading"></loading>
                <modal-x :show="showAlerts" @onclose="showAlerts = false">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="text-center">
                                <span class="glyphicon glyphicon-exclamation-sign" style="font-size: 3em; color: red;"></span>
                                <h4>{{ lang.postEditor.updateFail }}</h4>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div v-for="err in errMsgs" class="alert alert-warning">
                                <div class="row">
                                    <div class="col-xs-8">
                                        <p>{{ lang.postEditor['updateFail_' + err.code] }} {{ err.code === '8006' ? '(' + err.value + ')' : '' }}</p>
                                    </div>
                                    <div class="col-xs-4 text-right">
                                        <button v-if="['8000', '8003'].includes(err.code)" class="btn btn-primary" @click="() => { inView = 'postbase'; showAlerts = false; }">
                                            <span class="glyphicon glyphicon-chevron-right"></span> {{ lang.common.fix }}
                                        </button>
                                        <button v-if="['8004'].includes(err.code)" class="btn btn-primary" @click="() => { inView = 'prices'; showAlerts = false; }">
                                            <span class="glyphicon glyphicon-chevron-right"></span> {{ lang.common.fix }}
                                        </button>
                                        <button v-if="['8005', '8006', '8007'].includes(err.code)" class="public-btn btn-primary" @click="() => { showTagsLabels(); showAlerts = false; }">
                                            <span class="glyphicon glyphicon-chevron-right"></span> {{ lang.common.fix }}
                                        </button>
                                        <button v-if="['8002'].includes(err.code)" class="btn btn-primary" @click="() => { inView = 'images'; showAlerts = false; }">
                                            <span class="glyphicon glyphicon-chevron-right"></span> {{ lang.common.fix }}
                                        </button>
                                        <button v-if="['8008', '8009'].includes(err.code)" class="btn btn-primary" @click="() => { inView = 'categoryLabels'; showAlerts = false; }">
                                            <span class="glyphicon glyphicon-chevron-right"></span> {{ lang.common.fix }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </modal-x>
                <modal-x :show="isSelectingImage" @onclose="isSelectingImage = false" :content-style="{ maxWidth: '800px' }">
                    <image-list v-if="isSelectingImage" :user-id="postbase.userId" @onselect="onImgSelect" :processing="isProcessingImage"></image-list>
                </modal-x>
                <modal-x :show="isEditingPost" @onclose="isEditingPost = false">
                    <post-editor v-if="isEditingPost" :user-id="userId" :edit-post-id="editingPostId"></post-editor>
                </modal-x>
                <modal-x :show="showCategory" @onclose="showCategory = false" :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
                    <div class="modal-header" v-if="cpdCatEditable">
                        <button class="btn btn-default btn-sm" @click="showCategoryButtons = !showCategoryButtons">
                            <span class="glyphicon glyphicon-pencil"></span> {{ lang.common.editCategories }}
                        </button>
                    </div>
                    <category v-if="showCategory" :user-id="userId" :cat-node="catNode" :show-create-node="showCreateCatNode" @catSelected="onCatChange" :viewMode="{}" :showCheckbox="false" cat-type="listing" :expandAll="true" :showButtons="showCategoryButtons" @onChanges="onCategoryChanges"></category>
                </modal-x>
                <modal-x :show="showBuildings" @onclose="showBuildings = false" :content-style="{ maxWidth: '800px', height: 'calc(100% - 40px)' }">
                    <div class="modal-header">
                        <h4>{{ lang.common.selectBuilding }}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <input type="text" class="form-control" v-model="buildingSearch" placeholder="Search buildings..." @input="onBuildingSearch" autocomplete="off">
                        </div>
                        <ul v-if="buildingSuggestions.length > 0" class="list-group">
                            <li v-for="(suggestion, idx) in buildingSuggestions" :key="suggestion.id || idx" @click="onBuildingSelect(suggestion)" class="list-group-item list-group-item-action">
                                {{ suggestion.displayName }}
                            </li>
                        </ul>
                    </div>
                </modal-x>
                
                <!-- Header with shop info and navigation -->
                <div class="row" style="margin-bottom: 15px;">
                    <div class="mor-img col-xs-6 col-sm-4">
                        <img :src="cpdThumb" class="img-responsive img-thumbnail" style="max-height:50px;" />
                    </div>
                    <div class="col-xs-6 col-sm-8 text-right">
                        <button class="btn btn-success" v-if="postbase.stateCode === 0" @click="onShare">
                            <span class="glyphicon glyphicon-share"></span> {{ lang.common.share }}
                        </button>
                    </div>
                </div>
                <div v-if="isRootPost" class="row" style="margin-bottom: 15px;">
                    <div class="col-xs-12">
                        <div class="pull-right">
                            <button class="btn btn-default" @click="$router.push({ path: 'ShopInfo', query: { shopUserId: userId } })">
                                <span class="glyphicon glyphicon-home"></Span> {{ lang.common.shopInfo }}
                            </button>
                            <button class="btn btn-default" @click="$router.push({ path: 'PostList', query: { shopUserId: userId } })">
                                <span class="glyphicon glyphicon-list-alt"></span> {{ lang.postEditor.posts }}
                            </button>
                            <button class="btn btn-default" @click="$router.go(-1)">
                                <span class="glyphicon glyphicon-arrow-left"></span> {{ lang.common.back }}
                            </button>
                        </div>
                    </div>
                </div>
                
                <!-- Tab navigation -->
                <div class="row">
                    <div class="col-xs-12">
                        <ul class="nav nav-tabs" role="tablist">
                            <li role="presentation" :class="{ active: inView === 'postbase' }">
                                <a @click.prevent="changeView('postbase')">{{ lang.postEditor.postbase }}</a>
                            </li>
                            <li role="presentation" :class="{ active: inView === 'images' }">
                                <a @click.prevent="changeView('images')">{{ lang.postEditor.imageAndContent }}</a>
                            </li>
                            <li v-if="isRootPost" role="presentation" :class="{ active: inView === 'prices' }">
                                <a @click.prevent="changeView('prices')">{{ lang.postEditor.prices }}</a>
                            </li>
                            <li v-if="cpdIsRoot" role="presentation" :class="{ active: inView === 'tagsLabels' }">
                                <a @click.prevent="showTagsLabels">{{ lang.postEditor.tags }}</a>
                            </li>
                            <li v-if="isRootPost" role="presentation" :class="{ active: inView === 'categoryLabels' }">
                                <a @click.prevent="changeView('categoryLabels')">{{ lang.postEditor.categoryLabels }}</a>
                            </li>
                            <li v-if="cpdIsRoot" role="presentation" :class="{ active: inView === 'links' }">
                                <a @click.prevent="changeView('links')">{{ lang.postEditor.more }}</a>
                            </li>
                        </ul>
                        
                        <!-- Tab content -->
                        <div class="tab-content panel panel-default" style="border-top: none;">
                            <div class="panel-body">
                                <div v-if="inView === 'postbase'" class="postbase-tab">
                                    <div class="form-group">
                                        <label class="control-label">{{ lang.postEditor.title }}</label>
                                        <div class="input-group">
                                            <input class="form-control" type="text" v-model="cpdPostbase.title" @keydown="changePostbase('title', $event.target.value)">
                                            <div class="input-group-addon">
                                                <span v-if="isRootPost === false">
                                                    ( {{ lang.postEditor.seq }}: 
                                                    <input type="text" @keydown="changePostbase('seq', $event.target.value)" v-model="cpdPostbase.seq" style="width:50px;" /> )
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="form-group">
                                        <label class="control-label">{{ lang.postEditor.content }}</label>
                                        <textarea class="form-control" style="height:200px;" v-model="cpdPostbase.textMsg" @keydown="changePostbase('textMsg', $event.target.value)"></textarea>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <div class="form-group">
                                                <button class="btn btn-default btn-block" @click="showMainCatsClick">
                                                    <span class="glyphicon glyphicon-tags"></span> {{ catBtnLabel }}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="form-group">
                                                <button class="btn btn-default btn-block" @click="selectBuildingsClick">
                                                    <span class="glyphicon glyphicon-building"></span> {{ buildingBtnLabel }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="well well-sm">
                                                <div class="row">
                                                    <div class="col-xs-6">
                                                        <button class="btn btn-default" @click="selectLatLng">
                                                            <span class="glyphicon glyphicon-map-marker" style="color: green;"></span> 
                                                            {{ latLngBtnLabel }}
                                                        </button>
                                                        <button class="btn btn-default" @click="onSelectLocation">
                                                            <span class="glyphicon glyphicon-globe"></span> {{ lang.common.getLocation }}
                                                        </button>
                                                        <button class="btn btn-default" @click="onLatLngSelect({lat:null,lng:null})">
                                                            <span class="glyphicon glyphicon-remove"></span>
                                                        </button>
                                                    </div>
                                                    <div class="col-xs-6 text-right">
                                                        <button class="btn btn-default" @click="changePostbase('stateCode', 1 - cpdPostbase.stateCode)">
                                                            {{ lang.postEditor.public }}
                                                            <span v-if="cpdPostbase.stateCode !== 0" class="glyphicon glyphicon-unchecked"></span>
                                                            <span v-if="cpdPostbase.stateCode === 0" style="color: green;" class="glyphicon glyphicon-check"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div v-if="cpdIsRoot && cpdIsManagers" class="form-group">
                                        <label class="control-label">ExtRef</label>
                                        <textarea class="form-control" style="height:50px;" v-model="cpdPostbase.extRef" @keydown="changePostbase('extRef', $event.target.value)"></textarea>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-xs-12 text-center">
                                            <p class="text-muted">{{ postbase.zoneEditDatetime }}</p>
                                            <div>
                                                <template v-if="cpdEditing.postbase">
                                                    <button class="btn btn-warning" @click="cancelPostbaseEdit" style="width: 120px;">
                                                        {{ lang.postEditor.cancelEdit }}
                                                    </button>
                                                    <button class="btn btn-primary" @click="updatePostClick" style="width: 120px;">
                                                        {{ lang.postEditor.update }}
                                                    </button>
                                                </template>
                                                <template v-if="!cpdEditing.postbase">
                                                    <button class="btn btn-primary" @click="updatePostClick" style="width: 120px;">
                                                        {{ lang.postEditor.update }}
                                                    </button>
                                                </template>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div v-if="inView === 'images'" class="images-tab">
                                    <div class="panel panel-default">
                                        <div class="panel-body">
                                            <agx-medialist :files="images" v-on:removeclicked="onImageRemove" v-on:updateclicked="onImageUpdate"></agx-medialist>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <button class="btn btn-primary btn-block" style="height: 60px; font-size: 1.1em;" @click="showImgSelector(onPostImgSelect)">
                                                <span class="glyphicon glyphicon-plus"></span> {{ lang.postEditor.selectFile }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 15px;">
                                        <div class="col-xs-12">
                                            <div class="well" style="border: 2px dashed #ccc; height: 100px; display: flex; justify-content: center; align-items: center;" v-on:dragover.prevent v-on:drop="onFileDrop" contenteditable="true" v-on:paste="onPaste">
                                                <span class="text-muted" style="font-size: 1.2em;">{{ lang.postEditor.dropFile }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div v-if="inView === 'prices'" class="prices-tab">
                                    <post-price v-if="inView === 'prices' && apiClient !== null" :apiClient="apiClient" :postId="editPostId"></post-price>
                                </div>
                                
                                <div v-if="inView === 'tagsLabels'" class="tags-tab">
                                    <div class="panel panel-default">
                                        <div class="panel-heading">
                                            <h4>{{ lang.postEditor.tags }}</h4>
                                            <div v-if="cpdCatEditable" class="pull-right">
                                                <button class="btn btn-default btn-sm" @click="showTagButtons = !showTagButtons">
                                                    <span class="glyphicon glyphicon-pencil"></span>
                                                </button>
                                            </div>
                                        </div>
                                        <category :showButtons="showTagButtons" :viewMode="{}" :user-id="userId" :cat-node="tagCatNode" :show-create-node="showCreateTagCatNode" @catSelected="tagCatsSelected" :selected="postTagCats" cat-type="tag" :expandAll="true" @onChanges="onTagCategoryChanges"></category>
                                    </div>
                                </div>
                                
                                <div v-if="inView === 'categoryLabels'" class="categoryLabels-tab">
                                    <category-labels :user-id="userId" :post-id="editPostId" v-on:onError="(err) => { showAlerts = true; errMsgs = err.msgs; }"></category-labels>
                                </div>
                                
                                <div v-if="inView === 'links'" class="links-tab">
                                    <div v-if="cpdIsManagers">
                                        <ul class="nav nav-tabs">
                                            <li role="presentation" :class="{ active: inView2 === 'links' }">
                                                <a @click.prevent="changeView2('links')">{{ lang.postEditor.links }}/{{ lang.postEditor.video }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="inView2 === 'links'" style="margin-top: 15px;">
                                        <div class="panel panel-default">
                                            <div class="panel-heading">
                                                <button class="btn btn-success btn-sm" @click="loadPostLinks">
                                                    <span class="glyphicon glyphicon-refresh"></span> {{ lang.postEditor.loadLinks }}
                                                </button>
                                            </div>
                                            <div class="panel-body">
                                                <div v-if="showPostLinks">
                                                    <post-link :show-update="false" :show-remove="false" :show-create="true" @createclicked="createPostLink"></post-link>
                                                    <agx-linklist :links="postlinks" v-on:removeclicked="onPostLinkRemove" v-on:updateclicked="onPostLinkUpdate" v-on:setimgclicked="setPostLinkImg"></agx-linklist>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Child posts section -->
                <div v-if="isRootPost && inView === 'images'" class="row" style="margin-top: 20px;">
                    <div class="col-xs-12">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <button class="btn btn-default btn-block" @click="showChildPosts = !showChildPosts">
                                    <span :class="{ 'glyphicon-plus': !showChildPosts, 'glyphicon-minus': showChildPosts }" class="glyphicon"></span>
                                    {{ lang.postEditor.childPosts }}
                                </button>
                            </div>
                            <div class="panel-body" v-if="showChildPosts">
                                <post-list v-if="showChildPosts" view-mode="postRow" :user-id="userId" :initFilter="{ prid: editPostId }" @onselect="onPostSelect"></post-list>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import loading from '../components/base/Loading.vue';
import postList from './postList.vue';
import postLink from './postLink';
import postProps from './postProps.vue';
import MediaList from '../posts/components/AgxMediaList.vue';
import LinkList from '../posts/components/AgxLinkList.vue';
import ImageList from '../dashboards/imageList.vue';
import modalX from '../components/base/ModalX1.vue';
import category from './category.vue';
import categoryLabels from './categoryLabels.vue';
import apis from '../api/extApi.js';
import postPrice from './postPrice.vue';

export default {
    name: "postEditor",
    components: {
        postPrice: postPrice,
        categoryLabels: categoryLabels,
        category: category,
        postList: postList,
        ImageList: ImageList,
        postLink: postLink,
        postProps: postProps,
        AgxMedialist: MediaList,
        AgxLinklist: LinkList,
        modalX: modalX,
        loading: loading
    },
    filters: {
        CatName: function (cat) {
            if (cat) {
                return cat.name;
            }
            return "Please Select";
        },
        stringify: function (item) {
            return JSON.stringify(item);
        }
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        isRootPost: function () {
            return this.parentPostId === null;
        },
        cpdEditing: function () {
            return {
                props: this.editing.props === true,
                postbase: this.editing.postbase !== null
            };
        },
        cpdIsRoot: function () {
            return !this.isChild;
        },
        cpdPostbase: function () {
            return this.cpdGet("postbase");
        },
        catBtnLabel: function () {
            var ret = this.lang.common.selectCategory;
            var pb = this.cpdGet("postbase");

            if (pb !== null) {
                var cat = pb.category;
                if (typeof (cat) !== "undefined" && cat !== null) {
                    var parentName = pb.parentCategory !== null ? pb.parentCategory.name : "";
                    ret = parentName + "/" + cat.name;
                }
            }
            return ret;
        },
        buildingBtnLabel: function () {
            var ret = this.lang.common.selectBuilding;
            var pb = this.cpdGet("postbase");
            if (pb !== null) {
                var locationId = pb.locationId;
                if (typeof (locationId) !== "undefined" && locationId !== null) {
                    ret = pb.location !== null ? pb.location.displayName : "";
                }
            }
            return ret;
        },
        latLngBtnLabel: function () {
            var ret = "Select Lat Lng";
            var pb = this.cpdGet("postbase");
            if (pb !== null) {
                var latlngCsv = (pb.lat === null ? "" : pb.lat) + "," + (pb.lng === null ? "" : pb.lng);
                if (latlngCsv !== null && latlngCsv !== ",") {
                    ret = latlngCsv;
                }
            }
            return ret;
        },
        dashProfile: function () {
            return this.$store.getters.dashProfile;
        },
        cpdIsManagers: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAdmin === true || dp.isManager === true);
        },
        cpdThumb: function () {
            var img = (this.images !== null && this.images.length > 0) ? this.images[0] : null;
            if (img !== null) { return img.thumbPath; }
            return null;
        },
        cpdCatEditable: function () {
            return this.dashProfile && (!this.dashProfile.hasTeam || this.dashProfile.isAdmin);
        }
    },
    props: {
        "editPostId": { type: String, default: null },
        "userId": { type: String, default: null },
        "parentPostId": { type: String, default: null }
    },
    data: function () {
        return {
            apiClient: null,
            catCodes: apis.api.settings.catCodes,
            showCategory: false,
            showBuildings: false,
            buildingSearch: '',
            buildingSuggestions: [],
            selectedBuilding: null,
            catNode: null,
            showCreateCatNode: false,
            tagCatNode: null,
            showCreateTagCatNode: false,
            postTagCats: { catIds: [], timestamp: 1 },
            showPostLinks: false,
            postbase: {},
            stateCode: null,
            postId: null,
            isChild: false,
            images: [],
            postlinks: [],
            title: null,
            textMsg: null,
            category: null,
            props: [],
            editing: {
                postbase: null,
                props: null,
                postlink: { linkUrl: null, linkText: null, linkTitle: null, postId: null }
            },
            isSelectingImage: false,
            isProcessingImage: false,
            imgHanlder: null,
            inView: 'postbase',
            inView2: '',
            isEditingPost: false,
            editingPostId: null,
            isLoading: false,
            showChildPosts: false,
            showCategoryButtons: false,
            showTagButtons: false,
            showAlerts: false,
            errMsgs: []
        }
    },
    mounted: function () {
        var postClientParam = {
            postId: this.editPostId,
            userId: this.userId,
            isAdmin: this.cpdIsManagers,
            showBtns: false //this.cpdIsManagers 
        };
        console.log('editPostId is:', postClientParam);
        this.apiClient = apis.ui.getPostClient(postClientParam);
        this.loadItem();
    },
    methods: {
        onSelectLocation: function (post) {
            this.apiClient.loadingOverlay.show();
            setTimeout(()=>{
                this.apiClient.loadingOverlay.hide();
            },30000)
             let prm = this.mxnRequestPrm({type:"latlng",value:null});
                prm.then((ret) => {
                    this.apiClient.loadingOverlay.hide();
                    console.log("on select latlng result", ret);
                    //alert(JSON.stringify(ret));
                    let locationLatLng = {lat:ret.payload.latitude,lng:ret.payload.longitude};
                    this.onLatLngSelect(locationLatLng);
                    //this.$router.push({ name: "Gmap", query: { shopUserId: this.postbase.userId, lat: locationLatLng.lat, lng: locationLatLng.lng } });
                });
        },
        selectLatLng(){

            var mapInit = window.mapAppConfs.rootParams.onMapInit();
            mapInit.onMapShow(true);
            window.mapAppInst.mount();
            window.mapAppConfs.vueEventBus.on('map:click',(ev)=>{
                mapInit.onMapShow(false);
                this.onLatLngSelect(ev.clickedPoint);
            });
        },
        onLatLngSelect: function(latlng) {
            console.log('selected latlng',latlng);
            this.changePostbase('lat',latlng.lat);
            this.changePostbase('lng',latlng.lng);
        },
        onShare: function () {
            let item = this.postbase;
            this.mxnPromptShare({ url: item.itemPath });
        },
        onCategoryChanges(val) {
            console.log('on category changes', val);
            this.loadCategory();
        },
        onTagCategoryChanges(val) {
            console.log('on tag category changes', val);
            this.loadTagCatNode();
        },
        onPaste(event) {
            event.preventDefault();
            let clb = (event.clipboardData || window.clipboardData);
            var items = clb.items;
            var images = [];
            if (items && items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    var isImage = item.type.startsWith("image/");
                    if (isImage) {
                        images.push(item);
                    }
                }
            }
            var files = [];
            if (images.length > 0) {
                images.forEach(img => {
                    files.push(img.getAsFile());
                });
            }
            this.doFileUpload(files);
        },
        onFileDrop(event) {
            event.stopPropagation();
            event.preventDefault();
            console.log("file drop event", event);
            let files = event.dataTransfer.files;
            this.doFileUpload(files);
        },
        doFileUpload(files) {
            if (!files) return;
            var fileList = [...files];
            var data = new FormData();
            fileList.forEach(f => {
                console.log('the file is', f);
                data.append('file', f, f.name);
            });
            this.apiClient.uploadFilePrms(this.userId, data).done((ret) => {
                console.log('upload?FilePrms return', ret);
                if (ret.ok) {
                    var retFiles = ret.value;
                    retFiles.forEach((rFile) => {
                        this.onPostImgSelect(rFile);
                    });
                }
            });
        },
        changeView: function (newView) {
            this.inView = newView;
            if (this.inView === 'links') {
                this.changeView2('links');
                //this.loadPostLinks();
            }
        },
        changeView2: function (newView) {
            this.inView2 = newView;
            if (this.inView2 === 'links') {
                this.loadPostLinks();
            }
        },
        showImgSelector: function (handler) {
            this.isSelectingImage = true;
            this.imgHandler = handler;
        },
        onImgSelect: function (imgFile) {
            this.imgHandler(imgFile);
        },
        onPostImgSelect: function (ret) {
            this.isProcessingImage = true;
            this.apiClient.addFileToPostPrms({ postId: this.postId, fileName: ret.fileName })
                .done((addRet) => {
                    this.isProcessingImage = false;
                    this.images.push({ ...ret, postFileId: addRet.value, postId: this.postId });
                });
        },
        showPost: function (postId) {
            this.editingPostId = postId;
            this.isEditingPost = true;
        },
        onPostSelect: function (post) {
            this.showPost(post.postId);
        },
        onCatChange: function (catPair) {
            //var catPair = {parent:parentNode,child:catNode};
            console.log('selected catPair', catPair);
            var hasChilds = catPair.child && catPair.child.childs && catPair.child.childs.length > 0;
            if (hasChilds) return;//do not allow select parent node
            this.showCategory = false;
            this.changePostbase("category", catPair.child);
            this.changePostbase("parentCategory", catPair.parent);
        },
        loadItem: function () {
            this.postId = this.apiClient.postId;
            this.apiClient.loadingOverlay.show();
            this.apiClient.getPostByIdPrms(this.postId).done((post) => {
                if (post) {
                    this.postbase = post;
                    this.postId = post.postId;
                    this.title = post.title;
                    this.textMsg = post.textMsg;
                    this.category = post.category;
                    this.images = post.images;
                    this.stateCode = post.stateCode;
                    this.isChild = post.parentId !== null;
                    this.apiClient.loadingOverlay.hide();
                    this.selectedBuilding = post.location;
                }
            }).fail(() => {
                console.log('failed load post');
                this.apiClient.loadingOverlay.hide();
            });
        },
        setPostLinkImg: function (link) {
            this.isSelectingImage = true;
            this.imgHandler = (img) => {
                var updateVal = { id: link.id, linkImg: img.fileName + img.fileType };
                this.apiClient
                    .updatePostLinkImgPrms(updateVal)
                    .done((ret) => {
                        link.imgThumb = img.thumbPath;
                        link.linkImg = updateVal.linkImg;
                    });
            };
        },
        createPostLink: function (newLink) {
            var thisInst = this;
            var item = newLink; //this.editing.postlink;
            item.postId = this.postId;
            this.apiClient.loadingOverlay.show();
            this.apiClient.addPostLinkPrms(item)
                .done((ret) => {
                    this.apiClient.loadingOverlay.hide();
                    if (ret.ok === true) {
                        thisInst.postlinks.unshift(ret.value);
                    }
                });
        },
        onPostLinkUpdate: function (link) {
            this.apiClient.loadingOverlay.show();
            this.apiClient.updatePostLinkPrms(link).done(() => {
                this.apiClient.loadingOverlay.hide();
            });
        },
        onPostLinkRemove: function (link) {
            this.apiClient.loadingOverlay.show();
            this.apiClient.removePostLinkPrms(link).done((ret) => {
                this.apiClient.loadingOverlay.hide();
                if (ret.ok === true) {
                    var index = this.postlinks.indexOf(link);
                    this.postlinks.splice(index, 1);
                }
            });
        },
        loadPostLinks: function () {
            var thisInst = this;
            this.apiClient.loadingOverlay.show();
            this.apiClient.getPostLinksPrms(this.postId).done((ret) => {
                this.apiClient.loadingOverlay.hide();
                thisInst.postlinks = ret;
            });
            this.showPostLinks = true;
        },
        onImageUpdate: function (data) {
            var thisInst = this;
            this.apiClient.updatePostFilePrms(data).done(function (ret) {
                thisInst.images = ret.value;
            });
        },
        onImageRemove: function (data) {
            var thisInst = this;
            this.apiClient.removeFileFromPostPrms(data).done(function (ret) {
                thisInst.images = ret.value;
            });
        },
        onPriceChanges: function (e) {

        },
        cpdGet: function (name) {
            if (this.editing[name]) {
                return this.editing[name];
            }
            return this[name];
        },
        changePostbase: function (prop, val) {
            if (!this.editing.postbase) {
                this.editing.postbase = $.extend(true, {}, this.postbase);
            }
            this.editing.postbase[prop] = val;
        },
        cancelPostbaseEdit: function () {
            this.editing.postbase = null;
        },
        cancelPropsEdit: function () {
            this.editing.props = false;
        },
        updatePostClick: function () {
            var $this = this;
            var postData = $this.editing.postbase;
            if (postData === null) {
                this.apiClient.alertOlay.show("No Change Detected!");
                return;
            }
            if (postData.category) {
                postData.catId = postData.category.catId;
            }
            this.apiClient.loadingOverlay.show();

            this.apiClient.updatePostBasePrms(postData).done((e) => {
                this.apiClient.loadingOverlay.hide();
                if (e.ok !== true) {
                    //this.apiClient.alertOlay.show("Update Failed!");
                    this.showAlerts = true;
                    this.errMsgs = e.msgs;
                    return;
                }
                $this.postbase = e.value;
                $this.editing.postbase = null;
            });
        },
        setPropertiesClick: function () {
            this.apiClient.setProperties();
        },
        selectBuildingsClick: function () {
            this.showBuildings = true;
            this.loadBuildings();
        },
        loadBuildings() {
            //load buildings for user
            this.buildingSuggestions = [];
            if(this.buildingSearch === '') return;
            this.apiClient.geoApi.searchBuildingsPrms({building:this.buildingSearch}).done((ret) => {
                console.log('buildings:',ret);
                this.buildingSuggestions = ret.results || [];
            });
        },
        onBuildingSearch: function() {
            this.loadBuildings();
        },
        onBuildingSelect: function(building) {
            this.showBuildings = false;
            console.log('selected building',building);
            this.changePostbase('locationId',building.id);
            this.changePostbase('location',building);
            //this.selectedBuilding = building;
        },
        showMainCatsClick: function () {
            this.showCategory = true;
            this.loadCategory();
        },
        loadCategory() {
            this.apiClient.getCategoryNodePrms(this.catCodes.listing, this.userId).done((catNode) => {
                console.log('catNode is', catNode);
                this.catNode = catNode;
                this.showCreateCatNode = catNode === null;
            });
        },
        showTagsLabels() {
            this.changeView('tagsLabels');
            this.loadPostTags();

            this.$nextTick(() => {
                this.loadTagCatNode();
            });
        },
        loadTagCatNode() {
            this.apiClient.getCategoryNodePrms(this.catCodes.tag, this.userId).done((catNode) => {
                console.log('tag catNode is', catNode);
                this.tagCatNode = catNode;
                this.showCreateTagCatNode = catNode === null;
            });
        },
        loadPostTags() {
            this.apiClient.getPostCatsPrms(this.editPostId).done((ret) => {
                console.log('postTagCats', ret);
                if (ret && ret.length >= 0) {
                    this.postTagCats.catIds = ret.map(t => t.child.catId);
                    this.postTagCats.timestamp = Date.now();
                }
                console.log('mapped postTagCats', this.postTagCats);
            });
        },
        tagCatsSelected(cat) {
            var catPair = cat;
            var hasChilds = catPair.child && catPair.child.childs && catPair.child.childs.length > 0;
            if (hasChilds) return;//do not allow select parent node

            var catId = cat.child.catId;
            if (this.postTagCats.catIds.indexOf(catId) >= 0) {
                this.apiClient.removePostCatPrms({ catId: catId, postId: this.editPostId }).done((ret) => {
                    console.log("removePostCatPrms return", ret);
                    if (ret.ok === false) {
                        this.errMsgs = ret.msgs;
                        this.showAlerts = true;
                    }
                    this.loadPostTags();
                });
            } else {
                this.apiClient.addPostCatPrms({ postId: this.editPostId, catId: catId }).done((ret) => {
                    console.log("addPostCatPrms return", ret);
                    this.loadPostTags();
                });
            }
        }
    },
    created: function () {

    },
    destroyed: function () {
        this.apiClient.destroy();
    }
}

</script>